module.exports = __webpack_public_path__ + "static/img/loginBG.123291a2.png";